import { Seo } from "../components/site/Seo";
import { PageHero } from "../components/site/PageHero";

const CONTENT = {
  "privacy-policy": {
    title: "Privacy Policy",
    lines: ["Privacy Policy"],
    intro: "How Arc & Hollow handles the information you share with us.",
    body: [
      "This policy explains what personal information we collect through this website and enquiry form, how it is used, how long it is retained and the rights available to you under applicable data-protection law.",
      "We collect only the information you choose to provide — such as your name, contact details and a description of your project — in order to respond to your enquiry. We do not sell your information.",
      "For any questions about your data, please contact the studio using the details on our Contact page.",
    ],
  },
  "cookie-policy": {
    title: "Cookie Policy",
    lines: ["Cookie Policy"],
    intro: "How this website uses cookies and similar technologies.",
    body: [
      "This site uses a small number of cookies to understand how it is used and to remember your preferences. You can accept or decline non-essential cookies using the banner shown on your first visit.",
      "Essential cookies are required for the site to function. Analytics cookies, where enabled, help us improve the experience and are only set with your consent.",
    ],
  },
  "terms": {
    title: "Website Terms",
    lines: ["Website Terms"],
    intro: "The terms on which you may use this website.",
    body: [
      "All imagery marked as concept, visualisation, design development or material study represents proposed or in-progress work and should not be interpreted as photography of completed projects.",
      "Content on this website is provided for general information and is subject to change. It does not constitute a contractual offer.",
    ],
  },
};

export default function Legal({ page }) {
  const c = CONTENT[page];
  return (
    <>
      <Seo title={`${c.title} | Arc & Hollow`} description={c.intro} path={`/${page}`} />
      <PageHero overline="Legal" titleLines={c.lines} intro={c.intro} />
      <section className="container-x pb-28">
        <div className="max-w-2xl space-y-6">
          {c.body.map((p, i) => (
            <p key={i} className={`font-light leading-relaxed ${i === 0 ? "text-bronze italic" : "text-olive text-lg"}`}>{p}</p>
          ))}
        </div>
      </section>
    </>
  );
}
